import { render, staticRenderFns } from "./LightboxModal.vue?vue&type=template&id=16bb2662&scoped=true"
import script from "./LightboxModal.vue?vue&type=script&lang=js"
export * from "./LightboxModal.vue?vue&type=script&lang=js"
import style0 from "./LightboxModal.vue?vue&type=style&index=0&id=16bb2662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bb2662",
  null
  
)

export default component.exports